export const PERMISSIONS = {
  readAll: 'read',
  writeAll: 'write',
  locations: { read: ['mod_loc'], write: ['mod_loc_write'] },
  profile: { read: ['mod_profile'], write: ['mod_profile_write'] },
  finance: { read: ['mod_finance'], write: ['mod_finance_write'] },
  marketing: { read: ['mod_marketing'], write: ['mod_marketing_write'] },
  schedule: { read: ['mod_schedule'], write: ['mod_schedule_write'] },
  mvc: { read: ['mod_mvc'], write: ['mod_mvc_write'] },
  pro: { read: ['mod_proserv'], write: ['mod_proserv_write'] },
  it: { read: ['mod_it'], write: ['mod_it_write'] },
  veh: { read: ['mod_veh'], write: ['mod_veh_write'] },
  merchandising: { read: ['mod_merchandising'], write: ['mod_merchandising_write'] },
  telecom: { read: ['mod_telecom'], write: ['mod_telecom_write'] },
  specialty: { read: ['mod_loc', 'mod_veh'], write: ['mod_loc_write', 'mod_veh_write'] },
  map: { read: [], write: [] },
  doctors: { read: ['od_dir'], write: ['od_dir_write'] },
  contact: { write: ['mod_loc_contact_write'] },
  vendor: { read: ['mod_loc'], write: ['mod_loc_write', 'mod_vendor_write'] },
  vendorMaintenance: { read: ['mod_vendor_maintenance'], write: ['mod_vendor_maintenance_write'] },
  pxp: { read: ['mod_pxp'], write: ['mod_pxp_write'] },
  callForwarding: { read: ['mod_call_forwarding'], write: ['mod_call_forwarding_write'] },
};

// Authorized positions for Call Forwarding tab
// RM = RVP (Regional Vice President), AM = Area Manager, AV = Area VP
export const CALL_FORWARDING_AUTHORIZED_POSITIONS = ['RM', 'AM', 'AV'];
